import { fe$utils } from './v2-fgen-fengine.js';

console.log('[FE_tp] V 1.0.1');

function fet$unexpectedError(message) {
    console.log('Unexpected error occurred: ' + message);
    toggleError(true, message);
}
function fet$showSubmitSuccess() {
    //window.location = '#success';
    console.log('[t_CBaW] Showing success');
    //fe$utils.removeClass('submitting', document.getElementById('form'));
    document.getElementById('form').style.display = 'none';
    document.getElementById('blockThanks').style.display = 'block';

}
function fet$redirect(url) {
    console.log('[t_CBaW] Redirecting to ' + url);
    window.location.assign(url);
}
function fet$showSubmitError(errorMessage) {
    console.log('Obtained server response: ' + errorMessage);
    fe$utils.removeClass('submitting', document.getElementById('form'));
    // TODO: [NOTA] descomentar progress
    // document.getElementById('progress').style.display = 'none';
    toggleError(true, errorMessage); // This one does not show text
}

function fet$onSubmit() {
    //fe$utils.addClass('submitting', document.getElementById('form'));
}

function fet$showSuccessCookie(){}
function fea$acceptSuccess() {
    fet$acceptSuccess();
}
function fet$showForm() {
    document.getElementById('form').style.display = 'block';
    document.getElementById('unrecoverable').style.display = 'none';
    document.getElementById('blockThanks').style.display = 'none';

}
function fet$acceptSuccess() {
    console.log('Success accepted');
    if(!window.history.back())
        window.close()
}

/* Callback to inform langs available for configuration */
function fet$langsAvailable(langs, defLang) {
    console.log("[FE_tp][DL] default language: " + defLang)
    var langNode = document.getElementById('langs');
    var currLang = document.createElement('div');
    var availableLangs = document.createElement('div');
    currLang.setAttribute('id', 'currLang');
    availableLangs.setAttribute('id', 'availableLangs');
    availableLangs.style.display = 'none';
    currLang.addEventListener('click', showLangs.bind(this));

    for (var i = 0; i < langs.length; i++) {
        var listViewItem = document.createElement('div');
        var classes = 'lang';

        langNodes[langs[i]] = listViewItem;
        listViewItem.addEventListener('click', onLangChanged.bind(this, langs[i]));

        listViewItem.appendChild(document.createTextNode(langs[i]));

        if (langs[i] == defLang) {
            currLang.appendChild(document.createTextNode(langs[i]));
            classes += ' selected';
            console.log("appending attribute clases")
        }
        listViewItem.setAttribute('class', classes);
        availableLangs.appendChild(listViewItem);

        langNode.appendChild(currLang);
        langNode.appendChild(availableLangs);
    }
}

function fet$onRendering(inprogress) {
    console.log('Rendering? ' + inprogress)
    if (!inprogress) {
        var logoNode = document.getElementById('logo');
        if (!logoNode.hasChildNodes()) {
            fe$utils.addClass('nologo', document.body)
        } else {
            console.log('[PG] Has logo');
        }
    }
}

function fet$onProgress(amount, message) {
    console.log('[TPL] Progress: ' + amount + ' - ' + message);
    var ctr = document.getElementById('progress');
    ctr.style.display = 'block';
    var bar = document.getElementById('progress-content');
    var progress = Math.floor(amount * 1000) / 10;

    bar.style.width = progress + '%';
    console.log('[TPL] Set bar to: ' + bar.style.width);
    var msg = document.getElementById('progress-message');
    while (msg.hasChildNodes()) {
        msg.removeChild(msg.childNodes[0]);
    }
    msg.appendChild(document.createTextNode(message));

    var progressLbl = document.getElementById('progress-labelout');
    while (progressLbl.hasChildNodes()) {
        progressLbl.removeChild(progressLbl.firstChild);
    }
    progressLbl.appendChild(document.createTextNode(progress + '%'));
    if (amount == 1) {
        setTimeout(function () {
            ctr.style.display = 'none';
        }, 500);
    }
}

var langNodes = {}
var langsOpen = false;
function onLangChanged(lang) {
    var availableLangs = document.getElementById('availableLangs');
    availableLangs.style.display = 'none';

    console.log('Lang changed to: ' + lang);
    for (var k in langNodes) {
        if (k == lang) {
            langNodes[k].setAttribute('class', 'lang selected');
        } else {
            langNodes[k].setAttribute('class', 'lang');
        }
    }
    var currLang = document.getElementById('currLang');
    // currLang.innerHTML = lang;
    while (currLang.hasChildNodes()) {
        currLang.removeChild(currLang.firstChild);
    }
    currLang.appendChild(document.createTextNode(lang));
    fe$ngine.setLanguage(lang);
}

function showLangs() {
    var availableLangs = document.getElementById('availableLangs');
    if (langsOpen) {
        availableLangs.style.display = 'none';
    } else {
        availableLangs.style.display = 'block';
    }
    langsOpen = !langsOpen
}

function toggleError(visible, message) {
    var errDiv = document.getElementById('errors')
    errDiv.style.display = (visible ? 'block' : 'none');
    var errGen = document.getElementById('genericError');
    errGen.style.display = (message ? 'none' : 'block');
    var errSpec = document.getElementById('specificError');
    errSpec.style.display = (message ? 'block' : 'none');
    if (message) {
        while (errSpec.hasChildNodes()) {
            errSpec.removeChild(errSpec.firstChild);
        }
        errSpec.appendChild(document.createTextNode(message));
    }
    if (visible) {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        })
    }
}

function fet$onValidationPerformed(success, errors) {
    console.log('Validation detected with errors: ' + JSON.stringify(errors));
    toggleError(!success); // This one does not show text
}

function fet$onUnrecoverableError(code, message) {
    console.log('Detected unrecoverable error: ' + code + ' - ' + message);
    //window.location = '#uerror';
    document.getElementById('form').style.display = 'none';
    document.getElementById('unrecoverable').style.display = 'block';
    document.getElementById('progress').style.display = 'none';

    var msgEl = document.getElementById('unrecoverable-message');
    while (msgEl.hasChildNodes()) {
        msgEl.removeChild(msgEl.firstChild);
    }
    msgEl.appendChild(document.createTextNode(message));
}

                                     
export {
    fet$showSuccessCookie, fet$unexpectedError, fet$showSubmitSuccess, fet$redirect, fet$showSubmitError,
    fet$onSubmit, fea$acceptSuccess, fet$showForm, fet$acceptSuccess, fet$langsAvailable, fet$onRendering,
    fet$onProgress, onLangChanged, toggleError, fet$onValidationPerformed, fet$onUnrecoverableError
}